import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message, Input } from 'antd';
import { toggleUpdateAnnouncement } from '../../redux/actions/announcement/toggleUpdateAnnouncement';
import { updateAnnouncement } from '../../redux/actions/announcement/updateAnnouncement';

class UpdateAnnouncementModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    onFinish = async (values) => {
        await this.props.onUpdate(values.statement,
            this.props.token);
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Update Announcement"
                key={this.props.announcement?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'update-announcement-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="update-announcement-form"
                    name="basic"
                    initialValues={{
                        statement: this.props.announcement?.statement
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="statement"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <Input.TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.announcement.announcementUpdateVisible,
    loading: state.announcement.loading,
    token: state.auth.token,
    error: state.announcement.error,
    message: state.announcement.message,
    announcement:state.announcement.all
})

const mapDispatchToProps = dispatch => ({
    onUpdate: (statement, token) => dispatch(updateAnnouncement(statement, token)),
    onClose: () => dispatch(toggleUpdateAnnouncement()),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateAnnouncementModal);